import { useFormikContext } from 'formik';
import get from 'get-value';
import React, { useMemo } from 'react';
import { Props, TFormValues } from './Liabilities.types';
import LiabilitiesList from './LiabilitiesList/LiabilitiesList';

const Liabilities: React.FC<Props> = (props) => {
  const { values }: { values: TFormValues } = useFormikContext();
  const prefix = useMemo(() => props.prefix, [props.prefix]);
  const items = useMemo(() => get(values, prefix), [values, prefix]);
  const creditCommitments = useMemo(() => props.creditCommitments, [props.creditCommitments]);

  return (
    <>
      <LiabilitiesList items={items} creditCommitments={creditCommitments} prefix={prefix} />
    </>
  );
};

export default Liabilities;
